module.exports = {
    CALL_ME_BACK_BEHAVIOUR: 'CALL_ME_BACK_BEHAVIOUR',
    PHONE_INPUT_PREFIX_REGEX: /^(\+?\d{0,5})$/,
    PHONE_INPUT_VALUE_REGEX: /^(\d{0,13})$/,
    PREFIX_PHONE_INPUT: 'phonePrefix',
    NUMBER_PHONE_INPUT: 'phoneNumber',
    PREFIX_PHONE_SYMBOL: '+'
};